import Vue from "vue";
const templateId = document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./templates/" + templateId + "/findbutton.js";

let component = Vue.component("findbutton", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['jsonval'],
      methods: {
        test() {
          window.location.href = '/find/'
        }
      },
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/findbutton.js